import { render } from "./modalBioCurseur.vue?vue&type=template&id=93aee596&scoped=true"
import script from "./modalBioCurseur.vue?vue&type=script&lang=js"
export * from "./modalBioCurseur.vue?vue&type=script&lang=js"

import "./modalBioCurseur.vue?vue&type=style&index=0&id=93aee596&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93aee596"]])

export default __exports__